import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import KendoDataSourceBase from '../KendoDataSourceBase'
import TreeListDataSourceProps from './TreeListDataSourceProps'

import Schema from './Schema'
import Filter from '../KendoDataSourceBase/Filter'
import Group from '../KendoDataSourceBase/Group'
import Sort from '../KendoDataSourceBase/Sort'
import Transport from '../KendoDataSourceBase/Transport'

export default {
    props: TreeListDataSourceProps,
    mixins: [
        KendoBaseComponent,
        KendoDataSourceBase, 
        Filter,
        Group,
        Schema,
        Sort,
        Transport
    ],
    mounted() {
        this.kendoDataSource = new kendo.data.TreeListDataSource(this.widgetOptions)
    },
    methods: {
        kendoWidget() {
            return this.kendoDataSource || new kendo.dataTreeListDataSource(this.widgetOptions)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoTreeListDataSource/KendoTreeListDataSourceMixin.js